<!-- Search Field -->
<div *ngIf="searchable" style="padding-left: 10px;">
    <tyl-form-field label="Search" style="width: calc(100% - 95px)" [clearable]="true"
        (clearClickEvent)="performSearch()">
        <input matInput type="text" id="applicationMenuSearchField" [(ngModel)]="search"
            (keydown.enter)="performSearch()">
    </tyl-form-field>

    <button style="background-color: inherit; border: none;" (click)="performSearch()">
        <img src="./assets/images/search normal.png" title="Search" style="width: 25px; height: 25px;" />
    </button>
    <button class="mat-expansion-indicator collapseAllMenus" (click)="expandCollapseButtonClick(0)">
    </button>
    <button class="mat-expansion-indicator expandAllMenus" (click)="expandCollapseButtonClick(1)">
    </button>
</div>

<div #divMenu [class.staffPortalMenu]="searchable && userType == 1">
    <!-- Portals -->
    <div *ngFor="let portal of displayPortals">
        <!-- If there are child portals, show an expansion panel -->
        <mat-expansion-panel *ngIf="portal.IsGroup" [expanded]="portal.Expanded == 1"
            [class.mat-expansion-panel-expanded]="portal.Expanded == 1"
            [class.mat-expansion-panel-collapsed]="portal.Expanded != 1" (click)="menuClick($event);"
            (afterExpand)="menuToggled(portal, true)" (afterCollapse)="menuToggled(portal, false)">
            <mat-expansion-panel-header [attr.tylerastid]="'pnl-'+ portal.PortalName" style="height:48px;">
                <mat-panel-title>
                    <div [innerHTML]="portal.PortalName | translate | highlightSearch: searchValue" style="float: left">
                    </div>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <portal-menu [portals]="portal.ChildPortals" [topLevel]="false" [navigable]="navigable"
                [selectable]="selectable" [searchValue]="searchValue" [selectedPortals]="selectedPortals"
                (portalSelected)="portalSelected.emit($event)" (portalExpanded)="portalExpanded.emit($event)"
                (portalNavigated)="portalNavigated.emit($event)"></portal-menu>
        </mat-expansion-panel>

        <!-- If there are not child portals, show a button -->
        <button *ngIf="!portal.IsGroup && !selectable" mat-button
            [id]="'btn-'+ portal.GroupName + '-' + portal.PortalName"
            [ngClass]="{'pseudoHeader': topLevel, 'mat-expansion-panel': topLevel, 'mat-menu-item': !topLevel}"
            [disabled]="portal.Disabled" (click)="portalClick(portal);" role="menuitem"
            [class.selectedPortalHighlight]="portal.PortalName == selectedPortalName">
            <div [innerHTML]="portal.PortalName | translate | highlightSearch: searchValue"></div>
        </button>
        <div *ngIf="!portal.IsGroup && selectable"
            [ngClass]="{'pseudoHeader': topLevel, 'mat-expansion-panel': topLevel, 'mat-menu-item': !topLevel}">
            <tyl-checkbox [id]="'chk-'+ portal.GroupName + '-' + portal.PortalName"
                [checked]="selectedPortals[portal.Id]" (checkedChange)="portalCheckboxChange(portal, $event)"
                (click)="$event.stopPropagation()">
                <div [innerHTML]="portal.PortalName | translate | highlightSearch: searchValue"></div>
            </tyl-checkbox>
        </div>
    </div>
</div>